import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'custom-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss'],
})
export class TableComponent implements OnInit {
  @Input() tableHead: Array<string> = [];
  @Input() tableData: Array<any> = [];
  @Input() includeCheckboxes: boolean = false;
  @Output() getValue: EventEmitter<any> = new EventEmitter();
  @Output() onRowClick: EventEmitter<any> = new EventEmitter();
  @Output() onCheckboxToggled: EventEmitter<any> = new EventEmitter();

  hasListeners = false;
  hasValues = false;
  internalCheckedState: any = {};
  allChecked = false;
  checkbox;

  constructor(public sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.tableData.forEach( (row: any, index: number) => {
      this.internalCheckedState[index] = false;
    });

    this.hasListeners = this.onRowClick.observers.length > 0;
    if (this.tableData.filter( row => row.filter( cell => cell.value))) {
      this.hasValues = true;
    }
  }

  public is_array(item) {
    return Array.isArray(item);
  }

  public isChecked(index: number) {
    return this.internalCheckedState[index];
  }

  public toggleAllCheckbox() {
    console.log("Toggling all checkboxes");
    this.allChecked = !this.allChecked;

    this.tableData.forEach( (val, i) => {
      this.internalCheckedState[i] = this.allChecked;
      this.onCheckboxToggled.emit(this.internalCheckedState);
    })
    console.log(this.internalCheckedState)
  }

  public toggleCheckbox(index: number) {
    this.internalCheckedState[index] = !this.internalCheckedState[index];
    this.onCheckboxToggled.emit(this.internalCheckedState);
  }

  public clearCheckboxes() {
    this.internalCheckedState = {};
  }

  public rowClick(numericIndex: number, event: MouseEvent, row) {
    if ( (<HTMLInputElement> event.target).classList.contains('mat-checkbox-inner-container')) { return; }
    this.onRowClick.emit(numericIndex);
    if (row[0].value) { this.getValue.emit(row[0].value) }

  }

  getIDs(row: number, data: any) {
    let rowPrefix = row.toString();
    rowPrefix += '-';

    if (this.is_array(data)) {
      let retVal = '';
      for (const item of data) {
        if (typeof item !== 'undefined' && typeof item.data !== 'undefined') {
          retVal += `${rowPrefix}${item.data.replace(/\s/g, '_')} `;
        }
      }
      return retVal;
    } else {
      if (typeof data === 'undefined') {
        return rowPrefix;
      } else {
        return `${rowPrefix}${data.data.replace(/\s/g, '_')}`;
      }
    }
  }

  fixSpaces(val: string) {
    if (typeof val === 'undefined') {
      return '';
    } else {
      return val.replace(/\s/g, '_');
    }
  }
}
